"use strict";
// 생산 품목 / 고객 발주 (api·web·admin 공통)
Object.defineProperty(exports, "__esModule", { value: true });
exports.ORDER_EVENT_TYPES = exports.RESERVATION_STATUS = exports.ORDER_STAGE_VALUES = exports.ORDER_STAGE = exports.PURCHASE_ORDER_NO_PREFIX = exports.PRODUCT_CODE_PREFIX = exports.CUSTOMER_CODE_PREFIX = exports.PURCHASE_ORDER_STATUS_VALUES = exports.PURCHASE_ORDER_STATUS = void 0;
// 발주 상태 — 취소해도 기록은 남기고 CANCELLED 로만 되돌린다
exports.PURCHASE_ORDER_STATUS = {
    OPEN: "OPEN",
    CANCELLED: "CANCELLED",
};
exports.PURCHASE_ORDER_STATUS_VALUES = Object.values(exports.PURCHASE_ORDER_STATUS);
// 코드/번호 접두사 (예: CUS-0001, PRD-0001, PO-20261001-000001)
exports.CUSTOMER_CODE_PREFIX = "CUS";
exports.PRODUCT_CODE_PREFIX = "PRD";
exports.PURCHASE_ORDER_NO_PREFIX = "PO";
// 발주 진행 단계 — 접수 → 예약 → 생산 → 검수 → 출고
exports.ORDER_STAGE = {
    RECEIVED: "RECEIVED",
    RESERVED: "RESERVED",
    PRODUCING: "PRODUCING",
    INSPECTED: "INSPECTED",
    SHIPPED: "SHIPPED",
};
exports.ORDER_STAGE_VALUES = Object.values(exports.ORDER_STAGE);
// 자재 예약 상태
exports.RESERVATION_STATUS = {
    ACTIVE: "ACTIVE", // 예약 중
    CONSUMED: "CONSUMED", // 실사용 처리 완료 (미사용분은 해제됨)
    RELEASED: "RELEASED", // 사용 없이 해제
};
// 발주 이행 이력 유형
exports.ORDER_EVENT_TYPES = {
    RESERVE: "RESERVE",
    RELEASE: "RELEASE",
    CANCEL_RELEASE: "CANCEL_RELEASE", // 발주 취소로 인한 자동 해제
    CONSUME: "CONSUME",
    PRODUCE: "PRODUCE",
    INSPECT: "INSPECT",
    SHIP: "SHIP",
};
